import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PreviousVesselSummaryComponent } from './previous-vessel-summary.component';


const routes: Routes = [
  {
    path: '',
    component: PreviousVesselSummaryComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PreviousVesselSummaryRoutingModule {}
